// Encryption utility functions for user ID protection

export const encryptUserId = (userId) => {
  try {
    // Exclude specific Firebase key from encryption
    if (userId === 'hpgAHhsJTEfefxzcwofR4AfDuCr2') {
      return userId; // Return as-is without encryption
    }
    
    // Create a simple encryption using base64 and a salt
    const salt = process.env.REACT_APP_ENCRYPTION_SALT || 'slazySloth2024';
    const combined = userId + salt;
    const encrypted = btoa(combined);
    return encrypted;
  } catch (error) {
    // Fallback to original userId if encryption fails
    return userId;
  }
};

// Helper function to get encrypted userId from localStorage
export const getEncryptedUserId = () => {
  return localStorage.getItem('userId');
}; 